import { render, staticRenderFns } from "./ListRecurrence.vue?vue&type=template&id=2a64dd05"
import script from "./ListRecurrence.vue?vue&type=script&lang=js"
export * from "./ListRecurrence.vue?vue&type=script&lang=js"
import style0 from "./ListRecurrence.vue?vue&type=style&index=0&id=2a64dd05&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports